<template>
  <div
    :class="$b({ inCart: cartMode, inProductPage: productPageMode })"
  >
    <BaseHeading
      :size="headingSize"
      :class="[$b('title'), 'global-wrapper']"
    >
      {{ $tr(title) }}
    </BaseHeading>

    <Swiper
      :class="$b('products')"
      :breakpoints="{
        650: {
          slidesPerView: 2.3,
        },
        900: {
          slidesPerView: 3.3,
          scrollbar: {
            hide: false,
          },
        },
        1150: {
          slidesPerView: 4.3,
        },
      }"
      :slides-per-view="1.2"
      :slides-per-group="1"
      :space-between="24"
      :scrollbar="{ el: `.${$b('scrollbar')}`, hide: true }"
    >
      <SwiperSlide
        v-for="sku in visibleProducts"
        :key="sku"
      >
        <CrossSellItem
          :sku="sku"
          :cart-mode="cartMode"
          :product-page-mode="productPageMode"
        />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  name: 'CrossSell',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    products: { type: Array, required: true },
    title: { type: String, default: 'Explore the Collection' },
    cartMode: { type: Boolean, default: false },
    productPageMode: { type: Boolean, default: false },
  },
  async setup(props) {
    const { $product } = useNuxtApp()

    const productResponses = await $product.get(props.products)
    return {
      visibleProducts: productResponses
        .filter((product) => product?.heroDesigns?.length)
        .map((product) => product.sku)
    }
  },
  computed: {
    headingSize() {
      if (this.cartMode) return 'h3'
      if (this.productPageMode) return 'h4'
      return 'h2'
    },
  },
}
</script>

<style lang="postcss">
.CrossSell__title {
  @apply py-sm;
}

.CrossSell {
  .CrossSell--in-product-page {
    @apply md:py-md;
    @apply xl:py-0 xl:pb-md;
  }

  .CrossSell--in-cart {
    .CrossSell__title {
      @apply mdMax:pt-md;
    }
  }

  .CrossSell__scrollbar {
    @apply mt-xxs mx-auto
      relative left-0;
    border-radius: 18px;
    -ms-touch-action: none;
    background-color: transparent;
    height: 5px;
    max-width: 1500px;
    width: 100%;

    .swiper-scrollbar-drag {
      @apply bg-grey transition-colors;

      height: 100%;
      width: 100%;
      position: relative;
      border-radius: 10px;
      left: 0;
      top: 0;

      &:hover {
        @apply bg-off-black bg-opacity-30;
      }
    }

    .swiper-scrollbar-cursor-drag {
      cursor: move;
    }
  }

  .CrossSell__products {
    @apply w-full;
    --carousel-gutter: var(--outer-gutter);
    padding-left: var(--carousel-gutter);
    padding-right: var(--carousel-gutter);

    @screen xxl {
      --carousel-gutter: calc(
        ((100vw - theme('screens.xxl')) / 2) + var(--outer-gutter)
      );
    }

    &:not(.swiper-initialized) .swiper-wrapper {
      @apply space-x-sm;

      .swiper-slide {
        --slides-per-view: 1.2;
        max-width: calc(100% / var(--slides-per-view));

        @screen sm {
          --slides-per-view: 2.3;
        }

        @screen md {
          --slides-per-view: 3.3;
        }

        @screen xl {
          --slides-per-view: 4.3;
        }
      }
    }
  }
}
</style>
